import request from '@/util/request'


export function formal_loginin(data) {
  return request({
    url: '/formal_loginin.php',
    method: 'post',
    data: data
  })
}

export function formal_exchange(data) {
  return request({
    url: '/formal_exchange.php',
    method: 'post',
    data: data
  })
}

export function formal_zjxx(data) {
  return request({
    url: '/formal_zjxx.php',
    method: 'post',
    data: data
  })
}

export function task_show(query) {
  return request({
    url: '/task_show.php',
    method: 'get',
    params: query
  })
}

export function task_pic(data) {
  return request({
    url: '/task_pic.php',
    method: 'post',
    data: data
  })
}

export function task_videourl(query) {
  return request({
    url: '/task_videourl.php',
    method: 'get',
    params: query
  })
}

export function task_video(data) {
  return request({
    url: '/task_video.php',
    method: 'post',
    data: data
  })
}

export function task_receive(data) {
  return request({
    url: '/task_receive.php',
    method: 'post',
    data: data
  })
}

export function task_user(query) {
  return request({
    url: '/task_user.php',
    method: 'get',
    params: query
  })
}

export function question(query) {
  return request({
    url: '/question.php',
    method: 'get',
    params: query
  })
}

export function formal_receive(data) {
  return request({
    url: '/formal_receive.php',
    method: 'post',
    data: data
  })
}

export function fwl(query) {
  return request({
    url: '/fwl.php',
    method: 'get',
    params: query
  })
}
export function yr_loginin(data) {
  return request({
    url: '/yr_loginin.php',
    method: 'post',
    data: data
  })
}
export function yr_receive(data) {
  return request({
    url: '/yr_receive.php',
    method: 'post',
    data: data
  })
}


















export function myprize(query) {
  return request({
    url: '/myprize.php',
    method: 'get',
    params: query
  })
}
export function check(query) {
  return request({
    url: '/check.php',
    method: 'get',
    params: query
  })
}
export function receive(query) {
  return request({
    url: '/receive.php',
    method: 'get',
    params: query
  })
}

export function llmgaojian_chat(data) {
  return request({
    url: '/llmgaojian_chat',
    method: 'post',
    data: data
  })
}
